(() => {
  'use strict';
  const PRODUCT = 9658483605781;
  const DEVICE = 50364870918421;
  const EXTRA = 50353786126613;
  const ACCESSORY = 49991750844693;
  const PLANS = { 50345085403413: 691069747477, 50345085534485: 691069780245, 50345085632789: 691069813013 };
  const ALL_VARIANTS = [50345085403413, 50345085436181, 50345085468949, 50345085501717, 50345085534485, 50345085567253, 50345085600021, 50345085632789, 50345085665557];
  const variantId = item => Number(item.variant_id || item.id);
  const planId = item => Number(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || 0);
  const properties = item => Array.isArray(item.properties) ? Object.fromEntries(item.properties.filter(pair => Array.isArray(pair) && pair.length >= 2)) : item.properties || {};
  const isBase = item => Number(item.product_id) === PRODUCT || variantId(item) === DEVICE;
  function managedItems(cart) {
    const bundles = new Set(cart.items.filter(isBase).map(item => properties(item)._hhr_bundle).filter(Boolean));
    return cart.items.filter(item => {
      const owned = ALL_VARIANTS.includes(Number(properties(item)._hhr_parent_variant)) || bundles.has(properties(item)._hhr_bundle);
      return isBase(item) || (owned && (variantId(item) === EXTRA || (variantId(item) === ACCESSORY && properties(item)._hhr_accessory === 'initial')));
    });
  }
  function inspect(cart) {
    if (!Array.isArray(cart?.items)) return { active: true, valid: false };
    const active = cart.items.some(item => variantId(item) === DEVICE || (isBase(item) && properties(item)._hhr_bundle));
    if (!active) return { active: false, valid: true };
    const items = managedItems(cart);
    const devices = items.filter(item => variantId(item) === DEVICE);
    const subscriptions = items.filter(item => Number(item.product_id) === PRODUCT);
    const extras = items.filter(item => variantId(item) === EXTRA);
    const accessories = items.filter(item => variantId(item) === ACCESSORY);
    if (devices.length !== 1 || subscriptions.length !== 1 || extras.length > 1 || accessories.length > 1) return { active, valid: false };
    const device = devices[0];
    const subscription = subscriptions[0];
    const bundle = properties(subscription)._hhr_bundle;
    const starter = properties(subscription)._hhr_starter_bags;
    const starterValid = starter === '1' ? extras.length === 0 : starter === '4' && extras.length === 1;
    const valid = accessories.every(item => item.quantity === 1 && planId(item) === 0 && properties(item)._hhr_bundle === bundle) && starterValid && Boolean(bundle) && properties(device)._hhr_bundle === bundle && device.quantity === 1 && subscription.quantity === 1 && planId(device) === 0 && PLANS[variantId(subscription)] === planId(subscription) && typeof device.final_line_price === 'number' && device.final_line_price === 0 && extras.every(item => item.quantity === 1 && planId(item) === 0 && properties(item)._hhr_bundle === bundle && Number(properties(item)._hhr_parent_variant) === variantId(subscription));
    return { active, valid, items };
  }
  function matches(cart, expected) {
    if (!inspect(cart).valid) return false;
    return expected.every(wanted => cart.items.some(item => variantId(item) === Number(wanted.id) && planId(item) === Number(wanted.selling_plan || 0) && (properties(wanted)._hhr_bundle ? properties(item)._hhr_bundle === properties(wanted)._hhr_bundle && item.quantity === wanted.quantity : item.quantity >= wanted.quantity)));
  }
  async function request(url, body, fetcher = fetch) {
    const response = await fetcher(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
    if (!response.ok) throw new Error('cart-request');
    return response.json();
  }
  async function replace(cart, items, urls, fetcher = fetch) {
    const existing = managedItems(cart);
    if (existing.length) {
      await request(urls.update, { updates: Object.fromEntries(existing.map(item => [item.key, 0])) }, fetcher);
      const cleared = await request(urls.cart, null, fetcher);
      if (managedItems(cleared).length) throw new Error('cart-not-cleared');
    }
    await request(urls.add, { items }, fetcher);
    const result = await request(urls.cart, null, fetcher);
    if (!matches(result, items)) throw new Error('cart-combination');
    return result;
  }
  const api = { inspect, managedItems, matches, replace, request };
  window.HHRRentalCart = api;
  const element = document.getElementById('hhr-cart-config');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  let state = inspect(config.cart);
  let busy = false;
  let refreshPending;
  let errorMessage = '';
  const allowedForms = new WeakSet();
  const checkoutSelector = '[name="checkout"], a[href*="/checkout"]';
  const expressSelector = 'shopify-accelerated-checkout-cart, .shopify-payment-button';
  const text = key => config.text[key] || '';
  function paint(message = '') {
    document.querySelectorAll('form[action$="/cart"]').forEach(form => {
      let notice = form.querySelector('[data-hhr-cart-notice]');
      if (!notice && state.active) {
        notice = document.createElement('div');
        notice.dataset.hhrCartNotice = '';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.style.cssText = 'margin:16px 0;padding:14px;border:1px solid #d5d5d5;border-radius:6px;line-height:1.6';
        const copy = document.createElement('p');
        copy.dataset.hhrCartMessage = '';
        const link = document.createElement('a');
        link.href = config.planUrl;
        link.className = 'text-link';
        link.textContent = text('change');
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.hhrRemoveBundle = '';
        remove.className = 'text-link';
        remove.style.marginInlineStart = '16px';
        remove.textContent = text('remove');
        notice.append(copy, link, remove);
        const checkout = form.querySelector('.cart__checkout-wrapper');
        (checkout || form).prepend(notice);
      }
      if (notice) {
        notice.hidden = !state.active;
        notice.querySelector('[data-hhr-cart-message]').textContent = message || errorMessage || text(state.valid ? 'paired' : 'invalid');
        notice.querySelector('[data-hhr-remove-bundle]').disabled = busy;
      }
      form.querySelectorAll(checkoutSelector).forEach(button => {
        if (state.active && (!state.valid || busy)) button.setAttribute('aria-disabled', 'true');
        else if (button.dataset.hhrLocked === 'true') button.removeAttribute('aria-disabled');
        button.dataset.hhrLocked = String(state.active && (!state.valid || busy));
      });
      form.querySelectorAll(expressSelector).forEach(button => {
        if (state.active) {
          if (button.dataset.hhrHidden !== 'true') button.dataset.hhrPreviousDisplay = button.style.display;
          button.hidden = true; button.style.display = 'none'; button.dataset.hhrHidden = 'true';
        } else if (button.dataset.hhrHidden === 'true') {
          button.hidden = false; button.style.display = button.dataset.hhrPreviousDisplay || '';
          delete button.dataset.hhrHidden; delete button.dataset.hhrPreviousDisplay;
        }
      });
    });
  }
  async function refresh() {
    if (refreshPending) return refreshPending;
    refreshPending = request(`${config.cartUrl}.js`).then(cart => { state = inspect(cart); errorMessage = ''; paint(); return cart; }).catch(() => { if (state.active) { state.valid = false; errorMessage = text('error'); paint(); } throw new Error('cart-read'); }).finally(() => { refreshPending = null; });
    return refreshPending;
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches?.('form[action$="/cart"]')) return;
    if (allowedForms.has(form)) { allowedForms.delete(form); return; }
    if (!state.active) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true; paint(text('checking'));
    try {
      await refresh();
      if (!state.valid) return;
      busy = false; paint();
      allowedForms.add(form);
      form.requestSubmit(event.submitter || form.querySelector('[name="checkout"]'));
    } catch { errorMessage = text('error'); paint(); }
    finally { busy = false; paint(); }
  }, true);
  document.addEventListener('click', async event => {
    if (event.target.closest?.('shopify-buyer-consent')) return;
    const remove = event.target.closest?.('[data-hhr-remove-bundle]');
    const checkout = event.target.closest?.(`a[href*="/checkout"], ${expressSelector}`);
    if (!state.active || (!remove && !checkout)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!remove || busy) { paint(); return; }
    busy = true; paint(text('checking'));
    try {
      const cart = await request(`${config.cartUrl}.js`);
      const items = managedItems(cart);
      if (items.length) await request(config.updateUrl, { updates: Object.fromEntries(items.map(item => [item.key, 0])) });
      const result = await request(`${config.cartUrl}.js`);
      if (managedItems(result).length) throw new Error('cart-not-cleared');
      window.location.assign(config.cartUrl);
    } catch { state.valid = false; errorMessage = text('error'); paint(); }
    finally { busy = false; }
  }, true);
  ['cart:updated', 'ajaxProduct:added', 'drawerOpen.CartDrawer'].forEach(name => document.addEventListener(name, () => { refresh().catch(() => {}); }));
  window.addEventListener('pageshow', () => { refresh().catch(() => {}); });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; paint(); });
  });
  document.querySelectorAll('#CartDrawer [data-products], #CartPageForm [data-products]').forEach(node => observer.observe(node, { childList: true }));
  paint();
})();
